var render = function render(){var _vm=this,_c=_vm._self._c;return _c('styled-div',{attrs:{"breakpoint":_vm.breakpoint,"display":_vm.dropdownOpen ? 'block' : null}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }